import React, { useState, useEffect } from 'react';

// System theme by default; an explicit choice is stamped on <html data-theme>
// and persisted. tokens.css resolves all three states.
function stored() {
	try {
		return localStorage.getItem('nf-theme');
	} catch (e) {
		return null;
	}
}

export default function ThemeToggle() {
	const [theme, setTheme] = useState(stored());

	useEffect(() => {
		const root = document.documentElement;
		if (theme) root.setAttribute('data-theme', theme);
		else root.removeAttribute('data-theme');
		try {
			if (theme) localStorage.setItem('nf-theme', theme);
			else localStorage.removeItem('nf-theme');
		} catch (e) {
			/* storage blocked */
		}
	}, [theme]);

	const systemDark =
		typeof window !== 'undefined' &&
		window.matchMedia &&
		window.matchMedia('(prefers-color-scheme: dark)').matches;
	const isDark = theme ? theme === 'dark' : systemDark;

	return (
		<button
			type="button"
			className="nf-icon-btn nf-theme-btn"
			aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
			title="Toggle theme"
			onClick={() => setTheme(isDark ? 'light' : 'dark')}
		>
			<span aria-hidden="true">{isDark ? '☀' : '☾'}</span>
		</button>
	);
}
